/**
 * CUSTOM: Header enhancements
 * - Shopify editor reinitialization
 * - Inject custom menu items into mobile drawer
 */
(function () {
  function injectMobileMenuItems() {
    var dataEl = document.getElementById('custom-header-menu-items');
    if (!dataEl) return;

    var menuList = document.querySelector('#menu-drawer .hdt-menu-drawer__menu');
    if (!menuList) return;

    // Remove previously injected items
    menuList.querySelectorAll('.custom-mobile-menu-item').forEach(function (el) {
      el.remove();
    });

    try {
      var items = JSON.parse(dataEl.textContent);
      // Prepend items in reverse order so first item ends up on top
      for (var i = items.length - 1; i >= 0; i--) {
        var item = items[i];
        var li = document.createElement('li');
        li.className = 'custom-mobile-menu-item';
        var a = document.createElement('a');
        a.href = item.url;
        a.textContent = item.title;

        if (item.enable_background) {
          a.className = 'custom-mobile-menu-btn';
          a.style.setProperty('--custom-btn-bg', item.bg_color);
          a.style.setProperty('--custom-btn-color', item.text_color);
        } else {
          a.className = 'hdt-menu-drawer__menu-item';
        }

        li.appendChild(a);
        menuList.insertBefore(li, menuList.firstChild);
      }
    } catch (e) {
      // Silent fail
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectMobileMenuItems);
  } else {
    injectMobileMenuItems();
  }

  // Shopify editor reinitialization
  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('.hdt-sticky-header');
    if (header) {
      document.documentElement.style.setProperty(
        '--header-height',
        header.clientHeight.toFixed(2) + 'px'
      );
    }
    injectMobileMenuItems();
  });
})();
